import { render } from "./index.vue?vue&type=template&id=d910aab6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d910aab6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d910aab6"],['__file',"src/common/components/BaseCheckbox/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d910aab6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d910aab6', __exports__)) {
    api.reload('d910aab6', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=d910aab6&scoped=true", () => {
    api.rerender('d910aab6', render)
  })

}


export default __exports__